import {
  INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES,
  INVOICE_CHANGE_FILTER,
  INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES,
  INVOICE_FETCH_BY_ID,
  INVOICE_FETCH_BY_ID_FAILED,
  INVOICE_FETCH_BY_ID_SUCCESS,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED,
  INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS,
  INVOICE_FILTERED_FETCH,
  INVOICE_FILTERED_FETCH_FAILED,
  INVOICE_FILTERED_FETCH_SUCCESS,
  INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED,
  INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS
} from "./available";
import {RequestState} from "../../requestState";
import vue from "vue";
import _ from "lodash";

import {getInvoiceLogCandidatesSection} from '../getters/invoices'
import {arrayOverrideMergeRule} from "../../helpers/merge";


export default {
  [INVOICE_CHANGE_FILTER](state, filterDelta) {
    let resetToFirstPage = {};
    if (!filterDelta.pagination) { // not pagination change, so reset paging to first page
      resetToFirstPage = {
        pagination: {
          page: 1
        }
      }
    }

    let newFilter = _.mergeWith(state.invoices.filter, filterDelta, resetToFirstPage, arrayOverrideMergeRule);

    state.invoices.filter = newFilter
  },
  [INVOICE_FILTERED_FETCH](state) {
    state.invoices.requestState = RequestState.Loading;
    state.invoices.response = {}
  },
  [INVOICE_FILTERED_FETCH_SUCCESS](state, response) {
    state.invoices.requestState = RequestState.Success;
    state.invoices.response = response
  },
  [INVOICE_FILTERED_FETCH_FAILED](state, error) {
    state.invoices.requestState = RequestState.Failed;
  },

  [INVOICE_FETCH_BY_ID](state, {invoiceId}) {
    vue.set(state.invoices.items, invoiceId, {});
    vue.set(state.invoices.items[invoiceId], 'requestState', RequestState.Loading)
  },
  [INVOICE_FETCH_BY_ID_SUCCESS](state, {invoiceId, response}) {
    vue.set(state.invoices.items, invoiceId, {});
    vue.set(state.invoices.items[invoiceId], 'requestState', RequestState.Success);
    vue.set(state.invoices.items[invoiceId], 'response', response)
  },
  [INVOICE_FETCH_BY_ID_FAILED](state, {invoiceId}) {
    vue.set(state.invoices.items, invoiceId, {});
    vue.set(state.invoices.items[invoiceId], 'requestState', RequestState.Failed)
  },
  [INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES](state, {invoiceId, filterDelta}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);

    let resetToFirstPage = {};
    if (!filterDelta.pagination) { // not pagination change, so reset paging to first page
      resetToFirstPage = {
        pagination: {
          page: 1
        }
      }
    }

    let newFilter = _.mergeWith(section.filter, filterDelta, resetToFirstPage, (objValue, srcValue, key, object, source) => {
      if (_.isArray(srcValue)) {
        return srcValue
      }

      return undefined
    });

    section.filter = newFilter
  },
  [INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES](state, {invoiceId, filterDelta}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);
    section.clientFilter = {...section.clientFilter, ...filterDelta}
  },
  [INVOICE_FETCH_INVOICE_LOG_CANDIDATES](state, {invoiceId}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);
    vue.set(section, 'requestState', RequestState.Loading);
    vue.set(section, 'response', null)
  },
  [INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS](state, {invoiceId, response}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);
    vue.set(section, 'requestState', RequestState.Success);
    vue.set(section, 'response', response)
  },
  [INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED](state, {invoiceId, error}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);
    vue.set(section, 'requestState', RequestState.Failed);
    vue.set(section, 'error', error)
  },
  [INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS](state, {invoiceId, caseId, response}) {
    let section = getInvoiceLogCandidatesSection(state)(invoiceId);
    if (section.requestState !== RequestState.Success) {
      return // request not performed or in progress
    }

    const newCase = response.items[0]; // we always set caseId filter, so single response
    const caseIndex = _.findIndex(section.response.items, it => {
      return it.caseId === caseId
    });

    if (caseIndex < 0) { // not presents in report
      return;
    }

    if (response.items.length === 0) { // remove affected services, but not case (otherwise UI will be broken)
      section.response.items[caseIndex].affectedServices.list = [];
    } else {
      vue.set(section.response.items, caseIndex, newCase); // update case
    }
  },
  [INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED](state, {invoiceId, response, caseId}) {
    // no-op (show notification?)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/invoices.js